export default (value: string) => {
  const trimValue = value.replace(/\s/g, '');

  return /^[0-9]*$/.test(trimValue) && trimValue.length === 16;
};
